import ChallengeLeagueTags from "@Enums/ChallengeLeagueTags";
import type { ChallengeResponse } from "@Shared/schemas/challenges/challengeSchemas";

export enum BootcampChallengeStep {
  PASSING_BASICS = "PASSING_BASICS",
  DECISION_MAKING = "DECISION_MAKING",
  SCAN_RATE = "SCAN_RATE",
  SCAN_TIMING = "SCAN_TIMING",
  AWARENESS = "AWARENESS",
  CRITICAL_SCAN = "CRITICAL_SCAN",
  FINAL = "FINAL",
}

const BOOTCAMP_STEP_BY_UNLOCK_RATING: Record<number, BootcampChallengeStep> = {
  0: BootcampChallengeStep.PASSING_BASICS,
  100: BootcampChallengeStep.DECISION_MAKING,
  200: BootcampChallengeStep.SCAN_RATE,
  300: BootcampChallengeStep.SCAN_TIMING,
  400: BootcampChallengeStep.AWARENESS,
  500: BootcampChallengeStep.CRITICAL_SCAN,
  600: BootcampChallengeStep.FINAL,
};

export const resolveBootcampChallengeStep = (
  challenge?: Pick<ChallengeResponse, "tags" | "unlocked_at"> | null
): BootcampChallengeStep | undefined => {
  if (!challenge) return;

  const { tags, unlocked_at: unlockRating } = challenge;
  const isBootcamp = tags?.some(({ tag }) => tag === ChallengeLeagueTags.BOOTCAMP);

  return isBootcamp && unlockRating != null ? BOOTCAMP_STEP_BY_UNLOCK_RATING[unlockRating] : undefined;
};
